export const pageLoadEvent = 'pageLoad';
export const userSelectionEvent = 'userSelection';
export const autocompleteEvent = 'autocomplete';

export const specialtyType = 'specialty';
export const procedureType = 'procedure';
export const providerType = 'provider';
export const semanticType = 'semantic';
export const browseSpecialtyType = 'browse_specialty';

export const sectionType = {
    firstSection: 'firstSection',
    secondSection: 'secondSection',
};

export const METRICS_CONSTANTS = {
    DropdownItem: 'AutocompleteResultListItem',
    Textbox: 'TextEntryField',
};

export const SEND_METRIC_DEBOUNCE_WAIT_TIME = 500;

